import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";
const DEFAULT_SECONDARY_COLOR = "var(--label-accent)";

function IconAIReview({
    class: cssClass,
    color,
    secondaryColor
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const stroke = secondaryColor ?? `var(--icon-secondary-color, ${DEFAULT_SECONDARY_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M8 2c.118 0 .235.004.352.01l-.069.031c-.507.22-.864.59-1.07 1.02A5.001 5.001 0 0 0 3 8v4a1 1 0 0 0 1 1h4a5 5 0 0 0 4.937-4.21c.428-.205.798-.56 1.022-1.075l.03-.069A6 6 0 0 1 8 14H3.999a2 2 0 0 1-2-2V8a6 6 0 0 1 6-6zm1.522 4.507.38.884-2.394 2.691a.5.5 0 0 1-.747 0L5.377 8.527a.5.5 0 0 1 .746-.665l1.012 1.136L9.4 6.452l.122.055z"/>
            <path stroke={stroke} d="M11.418.882a.637.637 0 0 1 1.12-.09l.047.09.616 1.413.041.083a.979.979 0 0 0 .464.423l1.408.615.006.002.09.048a.637.637 0 0 1-.09 1.118h-.002l-1.412.617a.979.979 0 0 0-.464.422l-.04.083-.616 1.411h-.001a.636.636 0 0 1-1.168-.002L10.82 5.73a.98.98 0 0 0-.502-.508L8.88 4.586v-.001a.636.636 0 0 1 .003-1.166l1.413-.617a.98.98 0 0 0 .505-.506l.616-1.412.001-.001zM15.4 4.005zm-.423-.626zm.436.565v-.003a.517.517 0 0 1 0 .003z"/>
        </svg>
    );
}

export default IconAIReview;
